import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { getNotifications } from "../../services/portalAluno/notifications/notificationsService";
import type { ApplicationState } from "../../store";

export const portalNotificationsQueryKey = (idUsuario?: number) => [
  "portal-aluno",
  "notificacoes",
  idUsuario,
];

const useNotifications = () => {
  const auth = useSelector((state: ApplicationState) => state.auth.data);
  const idUsuario = auth?.idUsuario;

  return useQuery({
    enabled: Boolean(idUsuario),
    queryKey: portalNotificationsQueryKey(idUsuario),
    queryFn: () => getNotifications(),
  });
};

export default useNotifications;
